window.midilinks = {};
window.midibtns = {};
window.midiaccess = null;
window.midisettings = {};
const uuid = require("uuid").v4;
const { qs, midilearn } = require("../../libs/qs");
const VanillaContextMenu = require("./vanilla-context-menu");

const MIDIIDS = {};
module.exports = (r) => {
   
  function throttle(func, delay) {
    let lastCall = 0;
    return function (...args) {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return func(...args);
    };
  }



  function linkClick(el, id,pad) {
    if(!el){
      return;
    }
    // pad is for pad buttons
    if (!id && !el.id) {
      el.id = "link_" + uuid();
    }
    if (id) {
      el.id = id;
    }

    el.classList.add("midilinkclick");
    if(!pad){
      el.classList.add("ison");
      el.addEventListener("click", (e) => {
        el.classList.toggle("ison");
      });
    }
   
    const menu = new VanillaContextMenu({
      scope: el,
      transitionDuration: 0,
      menuItems: [
        {
          label: "Link to controler",
          callback: async () => {

            if(!pad){
              window.midilinking = {
                btn: true,
                inputid: el.id,
                input: el,
              };

            }else{
              window.midilinking = {
                btn: true,
                inputid: el.id,
                input: el,
                pad:true
              };
            }
           

            try {
              await midilearn("btn");
            } catch (e) {
            
              window.midilinking = null;
            }
          },
        },
        {
          label: "Unlik",
          callback: () => {
            //window.midibtns
            for (let i in window.midibtns) {
              if (window.midibtns[i].ctrlid === el.id) {
                delete window.midibtns[i];
              
              }
            }
          },
        },
      ],
    });

  
    return menu;
  }
  window.linkClick = linkClick;

//   linkClick(qs(".start"), "start");
//   linkClick(qs(".tempoplus"), "tempoplus");
//   linkClick(qs(".tempominus"), "tempominus");
//   linkClick(qs(".tap"), "tap");

  const throttleDelay = 150; // ms




 

  //listen to ctrl + -> and ctrl + <-


  let midi = null; // global MIDIAccess object
  function onMIDISuccess(midiAccess) {

    const ID = uuid();

    MIDIIDS[ID] = true;
    window.midiaccess = midiAccess;
    midi = midiAccess;
    const inputs = midi.inputs.values();

    // loop through all inputs
    for (
      var input = inputs.next();
      input && !input.done;
      input = inputs.next()
    ) {
      const inpt = input;
 
      if (!window.midisettings[input.value.id]) {
        window.midisettings[input.value.id] = {
          id: input.value.id,
          name: input.value.name,
          state: true,
          active: true,
          channel: "omni",
        };
      }

      // listen for midi messages
      input.value.onmidimessage = (event) => {
      
        if (!MIDIIDS[ID]) {
          return;
        }
        //   console.log("received midi message from device" + inpt.value.name, event.data)
        // console.log("midi channel is " + (event.data[0] & 0xf))
        // console.log("midi message type is " + (event.data[0] & 0xf0))

        // console.log(inpt)
        if (!window.midisettings[inpt.value.id].active) {
          //  console.log("midi device is not active")
          return;
        }
        //console.log("midi device is active")
        //console.log("midi filter is set to channel "+window.midisettings[inpt.value.id].channel)

        const midichannel = event.data[0] & 0xf;
        //console.log(midichannel,"midichannel",Number(window.midisettings[inpt.value.id].channel))
        if (window.midisettings[inpt.value.id].channel !== "omni") {
          if (
            midichannel !== Number(window.midisettings[inpt.value.id].channel)
          ) {
            ////     console.log("midi message is not on the right channel")
            return;
          }
        }

        //   console.log('ok it is the right channel')
        //   console.log(event.data[0], event.data[1], event.data[2])

        if (window.midilinking) {
          //   console.log("midi linking is active")

          if (event.data[0] == 176) {
            // console.log("midi message is a control change")

            const id = uuid();

            if (window.midilinking.btn) {
              for (let btn in window.midibtns) {
                if (
                  window.midibtns[btn].ctrlid === window.midilinking.inputid
                ) {
                  delete window.midibtns[btn];
                }
              }

              window.midibtns[id] = {
                id: id,
                input: window.midilinking.input,
                ctrlid: window.midilinking.inputid,
                midiid: event.data[0],
                ctid: event.data[1],
                state: true,
                pad:window.midilinking.pad
              };
            } else {
              // console.log("we are linking a knob")
              for (let lnk in window.midilinks) {
                //  console.log('we already have the following link',window.midilinks[lnk].ctid,"we compre with",window.midilinking.inputid)
                if (
                  window.midilinks[lnk].ctrlid === window.midilinking.inputid
                ) {
                
                  delete window.midilinks[lnk];
                }
              }

              window.midilinks[id] = {
                id: id,
                input: window.midilinking.input,
                ctrlid: window.midilinking.inputid,
                midiid: event.data[0],
                ctid: event.data[1],
              };
            }
          }

          window.midilinking = null;
          qs(".midimodal").dispatchEvent(new CustomEvent("close"));
        }

        for (let lk in window.midilinks) {
          if (window.midilinks[lk].midiid === event.data[0]) {
            if (window.midilinks[lk].ctid === event.data[1]) {
              let decimal_digits = 0;
              const x_str = window.midilinks[lk].input.step
                .toString()
                .split(".")[1];
              if (x_str !== undefined) {
                decimal_digits = x_str.length;
              }

              const min = Number(window.midilinks[lk].input.min);
              const max = Number(window.midilinks[lk].input.max);

              let val;
              if (Number(min) < 0) {
                if (event.data[2] > 62) {
                  val = (max / 64) * (event.data[2] - 62);
                } else {
                  val = -(Math.abs(Number(min)) - (max / 64) * event.data[2]);
                }
              } else {
                const pct = (event.data[2] / 127) * 100;

                //  console.log(pct)
                val = (pct * (max - min)) / 100 + min;
              }
              val = Number(val.toFixed(decimal_digits));
              if (val >= max) {
                val = max;
              }
              window.midilinks[lk].input.value = val;
              // console.log(val)
              window.midilinks[lk].input.dispatchEvent(new Event("change"));
            }
          }
        }

        for (let lk in window.midibtns) {
          if (window.midibtns[lk].midiid === event.data[0]) {
            if (window.midibtns[lk].ctid === event.data[1]) {
              if (window.midibtns[lk].wait) {
                continue;
              }
              let oldstate = window.midibtns[lk].state;
              if (event.data[2] === 0) {
                window.midibtns[lk].state = false;
              } else {
                window.midibtns[lk].state = true;
              }

              if (oldstate !== window.midibtns[lk].state) {
                try {
                  // console.log(window.midibtns[lk].input,throttle,throttleDelay)
                  if(!window.midibtns[lk].pad){
                    window.midibtns[lk].wait = true;
                    window.midibtns[lk].input.click();
                    setTimeout(() => {
                      delete window.midibtns[lk].wait;
                    }, throttleDelay);
                  }else{//only click if not 0

                    if(event.data[2] !== 0){
                     // window.midibtns[lk].wait = true;
                      window.midibtns[lk].input.click();
                      // setTimeout(() => {
                      //   delete window.midibtns[lk].wait;
                      // }, throttleDelay);

                    }


                  }
                
                  // throttle(window.midibtns[lk].input.click, throttleDelay)
                } catch (e) {
                  ;
                }
              }
            }
          }
        }

        // if note on
        //  console.log(event.data[0])
        if (event.data[0] === 146 || event.data[0] === 144) {


            if(!window.rootoctave){
              window.rootoctave = 0;
            }
          // window.rootoctave = 4;
          // we need to get the note number and trigger the corresponding source acco

          // get note number
          let note = event.data[1];
            
              // we need to subsctract 12 for each window.rootoctave to get the right note number

              note = note - (window.rootoctave * 12)

              // dispatch the note event to body    

                document.body.dispatchEvent(new CustomEvent("note", { detail: { note: note, state: event.data[2] } }));
        
        }
      };
    }
  }

  function onMIDIFailure(msg) {
    console.error(`Failed to get MIDI access - ${msg}`);
  }

  navigator.requestMIDIAccess().then(onMIDISuccess, onMIDIFailure);
  document.body.addEventListener("midirefresh", (e) => {
    for (let ID in MIDIIDS) {
      MIDIIDS[ID] = false;
    }


    navigator.requestMIDIAccess().then(onMIDISuccess, onMIDIFailure);
  });
};
